import React from "react";
import { withRouter } from "react-router-dom";
import LoadSpinner from "../../../common/spinner/loadSpinner";
import Menucustom from "../../../common/menu/menucustom";
import DashboardTipologiaSanzioneService from "./dashboardTipologiaSanzioneService";
import { Form, InputGroup } from "react-bootstrap";
import { BsFillCircleFill } from "react-icons/bs";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import NumberFormat from "react-number-format";
import {
  calculateTimeDifferenceTwoDates,
  geDataFormat,
  getColorState,
} from "../../../common/utils";
import { CDBCard, CDBCardBody, CDBDataTable, CDBContainer } from "cdbreact";
import { CSVLink, CSVDownload } from "react-csv";
import ingiunzioniList from "../../../common/mookup/MookUpIngunzioni";
import { Modal, Button, Row } from "react-bootstrap";
toast.configure();

class TipologiaSanzione extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      TipologiaSanzione: [
        {
          idAnagraficaTipologiaSanzione: 0,
          nomeViolazione: "",
          normaDiRiferimento:"",
          importo: "",
          importoRidotto: "",
          aggiungiPrezzoTratta: false,
          speseProcedura: false,
          statobottne: true,
        },
      ],
      creaNuovaTipologia:
        {
          idAnagraficaTipologiaSanzione: 0,
          nomeViolazione: "",
          normaDiRiferimento:"",
          importo: "",
          importoRidotto: "",
          aggiungiPrezzoTratta: false,
          speseProcedura: false,
        },
      abilitazioneDiModificaSuUnLinea: [], //è un array di chiavi per abilitare e disabilitare un bottone di un area
      loading: true,
      abilitaModificaLinea: [],
      eliminaModal: false,
      idDaEliminare: 0,
      AggiungiUnaLinea: false,
      nomeViolazione: "",
      loadingButton:false,
    };
    this.geDataFormat = geDataFormat.bind(this);
    this.getColorState = getColorState.bind(this);
    // this.onRowClick = this.onRowClick.bind(this);
  }

  componentDidMount() {
    this.dashboardTipologiaSanzioneService =
      new DashboardTipologiaSanzioneService();

    this.dashboardTipologiaSanzioneService.getDataTableTipologiaSanzione(
      (Tipologia) => {
        Tipologia.map((linee) => {
          linee.statobottne = true;
          linee.bottoniEditi = true;
          if (linee.speseProcedura === 0) {
            linee.speseProcedura = false;
          } else {
            linee.speseProcedura = true;
          }
          if (linee.aggiungiPrezzoTratta === 0) {
            linee.aggiungiPrezzoTratta = false;
          } else {
            linee.aggiungiPrezzoTratta = true;
          }

          // this.impoRIdo = linee.importoRidotto
          //   .toString()
          //   .substring(0, linee.importoRidotto.toString().length - 1);

          // linee.importoRidotto = parseFloat(this.impoRIdo);

          // // linee.importo = (linee.importo / 100)
          // this.importo = linee.importo + "0";

          // var arrayDiIMportoRidotto = linee.importoRidotto.toString().split("");

          //   console.log(arrayDiIMportoRidotto[arrayDiIMportoRidotto.length - 1]);
          //   if (arrayDiIMportoRidotto[arrayDiIMportoRidotto.length - 1] === "0") {
          //     linee.importoRidotto = linee.importoRidotto + "0";
          //   }

          linee.importoRidotto = parseFloat(linee.importoRidotto / 100)
            .toFixed(2)
            .toString()
            .replace(".", ",");

          // var arrayDiImporto = linee.importo.toString().split("");

          // console.log(arrayDiImporto[arrayDiImporto.length - 1]);
          // if (arrayDiImporto[arrayDiImporto.length - 1] === "0") {
          //   linee.importo = linee.importo + "0";
          // }

          linee.importo = parseFloat(linee.importo / 100)
            .toFixed(2)
            .toString()
            .replace(".", ",");
          // linee.importo = parseFloat(this.importo / 100).toFixed(2);
          // Tipologia.importo = parseFloat(Tipologia.importo / 100);
          // Tipologia.importoRidotto = parseFloat(
          //   Tipologia.importoRidotto / 100
          // );
        });
        // this.state.TipologiaSanzione = Tipologia;
        this.setState({ TipologiaSanzione: Tipologia });
      }
    );
    // this.state.TipologiaSanzione.map((val) => {

    //   this.setState()
    // });

    this.setState({ loading: false });
  }

  onChangeNomelineea(event) {
    const idInput = event.target.id;
    this.state.TipologiaSanzione[idInput].nomeViolazione = event.target.value;
    this.setState({ TipologiaSanzione: this.state.TipologiaSanzione });
  }

  annullaElimina() {
    this.setState({ eliminaModal: false });
  }

  confremaElimna() {
    this.setState({ loadingButton:true})
    this.dashboardTipologiaSanzioneService.deleteTipologia(
      this.state.idDaEliminare,
      (result) => {
        this.setState({ loadingButton:false})
        if (result.status === 200) {
          toast.success("Eliminato con successo");
        } else {
          toast.error("Qualcosa è andato storto");
        }
        this.dashboardTipologiaSanzioneService.getDataTableTipologiaSanzione(
          (Linee) => {
            Linee.map((linee) => {
              linee.statobottne = true;
              linee.bottoniEditi = true;

              // var arrayDiIMportoRidotto = linee.importoRidotto.toString().split("");

              // console.log(arrayDiIMportoRidotto[arrayDiIMportoRidotto.length - 1]);
              // if (arrayDiIMportoRidotto[arrayDiIMportoRidotto.length - 1] === "0") {
              //   linee.importoRidotto = linee.importoRidotto + "0";
              // }

              linee.importoRidotto = parseFloat(linee.importoRidotto / 100)
                .toFixed(2)
                .toString()
                .replace(".", ",");

              // var arrayDiImporto = linee.importo.toString().split("");

              //   console.log(arrayDiImporto[arrayDiImporto.length - 1]);
              //   if (arrayDiImporto[arrayDiImporto.length - 1] === "0") {
              //     linee.importo = linee.importo + "0";
              //   }

              linee.importo = parseFloat(linee.importo / 100)
                .toFixed(2)
                .toString()
                .replace(".", ",");
            });
            this.setState({ TipologiaSanzione: Linee, eliminaModal: false });
          }
        );
      }
    );
  }

  eliminaModal() {
    return (
      <>
        <Modal size="lg" show={this.state.eliminaModal}>
          <Modal.Header>
            <Modal.Title>Elimina Tipologia Sanzione</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Sei sicuro di eliminare la Tipologia Sanzione?
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={this.annullaElimina.bind(this)}
            >
              Annulla
            </Button>
            <Button variant="danger" disabled={this.state.loadingButton} onClick={this.confremaElimna.bind(this)}>
              {this.state.loadingButton ? <LoadSpinner/> : "Elimina Tipologia Sanzione"}
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }

  annullaAggiungi() {
    this.setState({
      AggiungiUnaLinea: false,
      creaNuovaTipologia: {
        idAnagraficaTipologiaSanzione: 0,
        nomeViolazione: "",
        importo: "",
        importoRidotto: "",
        aggiungiPrezzoTratta: false,
        speseProcedura: false,
      },
    });
  }

  confremaAggiungi() {
    this.nuovaTipologiaSanzione = {
      nomeViolazione: this.state.creaNuovaTipologia.nomeViolazione,
      normaDiRiferimento:this.state.creaNuovaTipologia.normaDiRiferimento,
      importo: this.state.creaNuovaTipologia.importo,
      importoRidotto: this.state.creaNuovaTipologia.importoRidotto,
      speseProcedura:
        this.state.creaNuovaTipologia.speseProcedura === true ? 1 : 0,
      aggiungiPrezzoTratta:
        this.state.creaNuovaTipologia.aggiungiPrezzoTratta === true ? 1 : 0,
    };

    // if (this.state.creaNuovaTipologia.importo.toString().includes(".")) {
    //   this.nuovaTipologiaSanzione.importo =
    //     this.state.creaNuovaTipologia.importo.toString().replace(".", "");
    // }

    // if (this.state.creaNuovaTipologia.importo.toString().includes(",")) {
    //   this.nuovaTipologiaSanzione.importo =
    //     this.state.creaNuovaTipologia.importo.toString().replace(",", "");
    // }

    // this.nuovaTipologiaSanzione.importo =
    //   this.state.creaNuovaTipologia.importo.toString().length === 1
    //     ? parseInt(this.state.creaNuovaTipologia.importo * 100)
    //     : this.state.creaNuovaTipologia.importo;
    // this.nuovaTipologiaSanzione.importoRidotto =
    //   this.nuovaTipologiaSanzione.importoRidotto.toString().length === 1
    //     ? parseInt(this.nuovaTipologiaSanzione.importoRidotto * 100)
    //     : this.nuovaTipologiaSanzione.importoRidotto;
    if (this.nuovaTipologiaSanzione.importo.toString().includes(".")) {
      this.importointero = this.nuovaTipologiaSanzione.importo
        .toString()
        .replace(".", "");
    }else{
      this.importointero = this.nuovaTipologiaSanzione.importo
    }
    if (this.nuovaTipologiaSanzione.importo.toString().includes(",")) {
      this.importointero = this.nuovaTipologiaSanzione.importo
        .toString()
        .replace(",", "");
    }else{
      this.importointero = this.nuovaTipologiaSanzione.importo
    }

    // this.importointero = this.nuovaTipologiaSanzione.importo
    // .toString()
    // .replace(".", "");

    if (
      this.nuovaTipologiaSanzione.importo.toString().includes(".") ||
      this.nuovaTipologiaSanzione.importo.toString().includes(",")
    ) {
      this.nuovaTipologiaSanzione.importo = parseFloat(this.importointero);
    } else {
      this.nuovaTipologiaSanzione.importo = parseFloat(
        this.importointero * 100
      );
    }

    if (this.nuovaTipologiaSanzione.importoRidotto.toString().includes(".")) {
      this.importointeroRido = this.nuovaTipologiaSanzione.importoRidotto.toString().replace(".", "");
    }else{
      this.importointeroRido = this.nuovaTipologiaSanzione.importoRidotto
    }
    if (this.nuovaTipologiaSanzione.importoRidotto.toString().includes(",")) {
      this.importointeroRido = this.nuovaTipologiaSanzione.importoRidotto.toString().replace(",", "");
    }else{
      this.importointeroRido = this.nuovaTipologiaSanzione.importoRidotto
    }

    // this.importointeroRido = this.nuovaTipologiaSanzione.importoRidotto.toString().replace(".", "");
    if (
      this.nuovaTipologiaSanzione.importoRidotto.toString().includes(".") ||
      this.nuovaTipologiaSanzione.importoRidotto.toString().includes(",")
    ) {
      this.nuovaTipologiaSanzione.importoRidotto = parseFloat(this.importointeroRido);
    } else {
      this.nuovaTipologiaSanzione.importoRidotto = parseFloat(this.importointeroRido * 100);
    }

    this.importointeroRido = 0
    this.importointero = 0

    // this.nuovaTipologiaSanzione.importo = parseFloat(this.nuovaTipologiaSanzione.importo * 100)
    // this.nuovaTipologiaSanzione.importoRidotto = parseFloat(this.nuovaTipologiaSanzione.importoRidotto * 100)

    // this.nuovaTipologiaSanzione.importo = this.state.creaNuovaTipologia.importo.toString().replace(".","")
    // this.nuovaTipologiaSanzione.importoRidotto = this.state.creaNuovaTipologia.importoRidotto.toString().replace(".","")
    this.setState({loadingButton:true})
    this.dashboardTipologiaSanzioneService.insertTipologia(
      this.nuovaTipologiaSanzione,
      (result) => {
        this.setState({loadingButton:false})
        if (result.status === 200) {
          toast.success("Tipologia Sanzione aggiunta con successo");
        } else {
          // console.log(this.nuovaTipologiaSanzione);
          toast.error("Qualcosa è andato storto");
        }

        this.dashboardTipologiaSanzioneService.getDataTableTipologiaSanzione(
          (Tipologia) => {
            Tipologia.map((linee) => {
              linee.statobottne = true;
              linee.bottoniEditi = true;
              if (linee.speseProcedura === 0) {
                linee.speseProcedura = false;
              } else {
                linee.speseProcedura = true;
              }
              if (linee.aggiungiPrezzoTratta === 0) {
                linee.aggiungiPrezzoTratta = false;
              } else {
                linee.aggiungiPrezzoTratta = true;
              }

              // Tipologia.importo = parseFloat(Tipologia.importo / 100).toFixed(
              //   2
              // );
              // Tipologia.importoRidotto = parseFloat(
              //   Tipologia.importoRidotto / 100
              // );
              //     var arrayDiImporto = linee.importo.toString().split("");

              // console.log(arrayDiImporto[arrayDiImporto.length - 1]);
              // if (arrayDiImporto[arrayDiImporto.length - 1] === "0") {
              //   linee.importo = linee.importo + "0";
              // }

              linee.importo = parseFloat(linee.importo / 100)
                .toFixed(2)
                .toString()
                .replace(".", ",");
              //  var arrayDiIMportoRidotto = linee.importoRidotto.toString().split("");

              //   console.log(arrayDiIMportoRidotto[arrayDiIMportoRidotto.length - 1]);
              //   if (arrayDiIMportoRidotto[arrayDiIMportoRidotto.length - 1] === "0") {
              //     linee.importoRidotto = linee.importoRidotto + "0";
              //   }

              linee.importoRidotto = parseFloat(linee.importoRidotto / 100)
                .toFixed(2)
                .toString()
                .replace(".", ",");
            });
            // this.state.TipologiaSanzione = Tipologia;
            this.setState({
              TipologiaSanzione: Tipologia,
              AggiungiUnaLinea: false,
              creaNuovaTipologia: {
                idAnagraficaTipologiaSanzione: 0,
                nomeViolazione: "",
                importo: "",
                importoRidotto: "",
                aggiungiPrezzoTratta: false,
                speseProcedura: false,
              },
            });
          }
        );
      }
    );
  }

  onChangeNuovaLinea(event) {
    this.state.creaNuovaTipologia.nomeViolazione = event.target.value;
    this.setState({ creaNuovaTipologia: this.state.creaNuovaTipologia });
  }
  onChangeNormaDiRiferimentoNuovaLinea(event) {
    this.state.creaNuovaTipologia.normaDiRiferimento = event.target.value;
    this.setState({ creaNuovaTipologia: this.state.creaNuovaTipologia });
  }
  onChangeImporto(event) {
    this.state.creaNuovaTipologia.importo = event.target.value.toString().replace(".",",");
    this.setState({
      creaNuovaTipologia: this.state.creaNuovaTipologia,
    });
  }

  onChangeImportoRidotto(event) {
    this.state.creaNuovaTipologia.importoRidotto = event.target.value.toString().replace(".",",");
    this.setState({
      creaNuovaTipologia: this.state.creaNuovaTipologia,
    });
  }

  onChangeSpesaProcedura(event) {
    // console.log(event.target.value)
    if (this.state.creaNuovaTipologia.speseProcedura)
      this.state.creaNuovaTipologia.speseProcedura = false;
    else this.state.creaNuovaTipologia.speseProcedura = true;
    this.setState({ creaNuovaTipologia: this.state.creaNuovaTipologia });
    // console.log(this.state.creaNuovaTipologia.speseProcedura);
  }

  onChangeAggiungiPrezzoTratta(event) {
    // console.log(event.target.value)
    if (this.state.creaNuovaTipologia.aggiungiPrezzoTratta)
      this.state.creaNuovaTipologia.aggiungiPrezzoTratta = false;
    else this.state.creaNuovaTipologia.aggiungiPrezzoTratta = true;
    this.setState({ creaNuovaTipologia: this.state.creaNuovaTipologia });
    // console.log(this.state.creaNuovaTipologia.aggiungiPrezzoTratta);
  }

  AggiungiUnaLinea() {
    return (
      <>
        <Modal size="lg" show={this.state.AggiungiUnaLinea}>
          <Modal.Header>
            <Modal.Title>Aggiungi una nuova Tipologia Sanzione</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <label>Nome Tipologia Sanzione</label>
            <input
              className="form-control"
              type="text"
              value={this.state.creaNuovaTipologia.nomeViolazione}
              onChange={this.onChangeNuovaLinea.bind(this)}
            />
            <label>Norma di Riferimento</label>
            <input
              className="form-control"
              type="text"
              value={this.state.creaNuovaTipologia.normaDiRiferimento}
              onChange={this.onChangeNormaDiRiferimentoNuovaLinea.bind(this)}
            />
            <div className="row">
              <div className="col">
                <label>Importo</label>
                <div className="input-group mb-3">
                  <div className="input-group-prepend">
                    <span className="input-group-text">€</span>
                  </div>
                  <input
                    className="form-control"
                    type="number"
                    value={this.state.creaNuovaTipologia.importo}
                    onChange={this.onChangeImporto.bind(this)}
                  />
                </div>
              </div>
              <div className="col">
                <label>Importo Ridotto</label>
                <div className="input-group mb-3">
                  <div className="input-group-prepend">
                    <span className="input-group-text">€</span>
                  </div>
                  <input
                    className="form-control"
                    type="number"
                    value={this.state.creaNuovaTipologia.importoRidotto}
                    onChange={this.onChangeImportoRidotto.bind(this)}
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col">
                <label>Spese Procedura </label>
                <BootstrapSwitchButton
                  // disabled={this.state.disableInput}
                  disabled={false}
                  checked={this.state.creaNuovaTipologia.speseProcedura}
                  onChange={this.onChangeSpesaProcedura.bind(this)}
                  onlabel="Si"
                  offlabel="No"
                  style="w-100 mx-1"
                />
              </div>
              <div className="col">
                <label>Prezzo Tratta </label>
                <BootstrapSwitchButton
                  // disabled={this.state.disableInput}
                  disabled={false}
                  checked={this.state.creaNuovaTipologia.aggiungiPrezzoTratta}
                  onChange={this.onChangeAggiungiPrezzoTratta.bind(this)}
                  onlabel="Si"
                  offlabel="No"
                  style="w-100 mx-1"
                />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={this.annullaAggiungi.bind(this)}
            >
              Annulla
            </Button>
            <Button
              variant="primary"
              disabled={this.state.loadingButton || this.state.creaNuovaTipologia.nomeViolazione?.length < 4}
              onClick={this.confremaAggiungi.bind(this)}
            >
              {this.state.loadingButton ? <LoadSpinner/> : "Aggiungi Tipologia Sanzione"}
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }

  onChangeEditNomeViolazione(event) {
    const index = event.target.id;
    this.state.TipologiaSanzione[index].nomeViolazione = event.target.value;
    // this.state.TipologiaSanzione.nomeViolazione = event.target.value;
    this.setState({ TipologiaSanzione: this.state.TipologiaSanzione });
  }
  onChangeEditNormaDiRiferimento(event) {
    const index = event.target.id;
    this.state.TipologiaSanzione[index].normaDiRiferimento = event.target.value;
    // this.state.TipologiaSanzione.nomeViolazione = event.target.value;
    this.setState({ TipologiaSanzione: this.state.TipologiaSanzione });
  }
  onChangeEditImporto(event) {
    const index = event.target.id;
    this.state.TipologiaSanzione[index].importo = event.target.value;
    // this.state.TipologiaSanzione.importo = event.target.value;
    this.setState({ TipologiaSanzione: this.state.TipologiaSanzione });
  }
  onChangeEditImportoRidotto(event) {
    const index = event.target.id;
    this.state.TipologiaSanzione[index].importoRidotto = event.target.value;
    // this.state.TipologiaSanzione.importoRidotto = event.target.value;
    this.setState({ TipologiaSanzione: this.state.TipologiaSanzione });
  }
  //   onChangeEditPrezzoTratta(id) {
  //     const index = id;
  //     // console.log(event)
  //     if (this.state.TipologiaSanzione[index].aggiungiPrezzoTratta)
  //       this.state.TipologiaSanzione[index].aggiungiPrezzoTratta = false;
  //     else this.state.TipologiaSanzione[index].aggiungiPrezzoTratta = true;
  //     this.setState({ TipologiaSanzione: this.state.TipologiaSanzione });
  //     console.log(this.state.TipologiaSanzione[index].aggiungiPrezzoTratta);
  //   }

  //   onChangeEditSpeseProgedura(event) {
  //     const index = event.target.id;
  //     if (this.state.TipologiaSanzione[index].aggiungiPrezzoTratta)
  //       this.state.TipologiaSanzione[index].aggiungiPrezzoTratta = false;
  //     else this.state.TipologiaSanzione[index].aggiungiPrezzoTratta = true;
  //     this.setState({ TipologiaSanzione: this.state.TipologiaSanzione });
  //     console.log(this.state.TipologiaSanzione[index].aggiungiPrezzoTratta);
  //   }

  tabellaAree() {
    return (
      <>
        <table class="table table-bordered text-center">
          <thead>
            <tr>
              <th scope="col">Nome Tipologia Sanzione</th>
              <th scope="col">Norma di Riferimento</th>
              <th scope="col">Importo</th>
              <th scope="col">Importo Ridotto</th>
              <th scope="col">Prezzo Tratta</th>
              <th scope="col">Spese Procedura</th>
              <th scope="col">Azioni</th>
            </tr>
          </thead>
          <tbody>
            {this.state.TipologiaSanzione.map((linee, index) => {
              return (
                <>
                  <tr className="">
                    <th className="col-md-3">
                      <input
                        id={index}
                        disabled={linee.statobottne}
                        className="form-control"
                        type="text"
                        value={linee.nomeViolazione}
                        onChange={this.onChangeEditNomeViolazione.bind(this)}
                      />
                    </th>
                    <th className="col-md-4">
                      <input
                        id={index}
                        disabled={linee.statobottne}
                        className="form-control"
                        type="text"
                        value={linee.normaDiRiferimento}
                        onChange={this.onChangeEditNormaDiRiferimento.bind(this)}
                      />
                    </th>
                    <th>
                      <div className="input-group mb-3">
                        <div className="input-group-prepend">
                          <span className="input-group-text">€</span>
                        </div>
                        <input
                          id={index}
                          disabled={linee.statobottne}
                          className="form-control"
                          type="text"
                          value={linee.importo}
                          // value={linee.importo}
                          onChange={this.onChangeEditImporto.bind(this)}
                        />
                      </div>
                    </th>
                    <th>
                      <div className="input-group mb-3">
                        <div className="input-group-prepend">
                          <span className="input-group-text">€</span>
                        </div>
                        <input
                          id={index}
                          disabled={linee.statobottne}
                          className="form-control"
                          type="text"
                          value={linee.importoRidotto}
                          // value={linee.importoRidotto}
                          onChange={this.onChangeEditImportoRidotto.bind(this)}
                        />
                      </div>
                    </th>
                    <th>
                      {linee.bottoniEditi ? (
                        <>
                          {this.state.TipologiaSanzione[index]
                            .aggiungiPrezzoTratta ? (
                            <ul class="list-group">
                              <li class="list-group-item active text-center">
                                Si
                              </li>{" "}
                            </ul>
                          ) : (
                            <ul class="list-group">
                              <li class="list-group-item text-center">No</li>{" "}
                            </ul>
                          )}
                          {/* <input
                            id={index}
                            disabled={linee.statobottne}
                            className="form-control"
                            type="text"
                            value={linee.aggiungiPrezzoTratta}
                            // onChange={this.onChangeNomelineea.bind(this)}
                          /> */}
                        </>
                      ) : (
                        <BootstrapSwitchButton
                          // disabled={this.state.disableInput}
                          disabled={false}
                          //   id={index}
                          checked={
                            this.state.TipologiaSanzione[index]
                              .aggiungiPrezzoTratta === 1
                              ? true
                              : false
                          }
                          //   onChange={this.onChangeEditPrezzoTratta.bind(index)}
                          onChange={() => {
                            if (
                              this.state.TipologiaSanzione[index]
                                .aggiungiPrezzoTratta
                            )
                              this.state.TipologiaSanzione[
                                index
                              ].aggiungiPrezzoTratta = false;
                            else
                              this.state.TipologiaSanzione[
                                index
                              ].aggiungiPrezzoTratta = true;
                            //   this.setState({ TipologiaSanzione: this.state.TipologiaSanzione });
                          }}
                          onlabel="Si"
                          offlabel="No"
                          style="w-100 mx-1"
                        />
                      )}
                    </th>
                    <th>
                      {linee.bottoniEditi ? (
                        <>
                          {this.state.TipologiaSanzione[index]
                            .speseProcedura ? (
                            <ul class="list-group">
                              <li class="list-group-item active text-center">
                                Si
                              </li>{" "}
                            </ul>
                          ) : (
                            <ul class="list-group">
                              <li class="list-group-item text-center">No</li>{" "}
                            </ul>
                          )}
                          {/* <input
                            id={index}
                            disabled={linee.statobottne}
                            className="form-control"
                            type="text"
                            value={linee.speseProcedura}
                            // onChange={this.onChangeNomelineea.bind(this)}
                          /> */}
                        </>
                      ) : (
                        <BootstrapSwitchButton
                          // disabled={this.state.disableInput}
                          disabled={false}
                          checked={linee.speseProcedura === 0 ? false : true}
                          //   onChange={this.onChangeEditSpeseProgedura.bind(this)}
                          onChange={() => {
                            if (
                              this.state.TipologiaSanzione[index].speseProcedura
                            ) {
                              this.state.TipologiaSanzione[
                                index
                              ].speseProcedura = false;
                            } else {
                              this.state.TipologiaSanzione[
                                index
                              ].speseProcedura = true;
                            }
                            //   this.setState({ TipologiaSanzione: this.state.TipologiaSanzione });
                          }}
                          onlabel="Si"
                          offlabel="No"
                          style="w-100 mx-1"
                        />
                      )}
                    </th>
                    <td>
                      {linee.bottoniEditi ? (
                        <>
                          <button
                            className="btn btn-primary"
                            onClick={
                              () => {
                                this.dashboardTipologiaSanzioneService.getDataTableTipologiaSanzione(
                                  (Linee) => {
                                    Linee.map((linee, indeds) => {
                                      if (indeds === index) {
                                        linee.statobottne = false;
                                        linee.bottoniEditi = false;
                                      } else {
                                        linee.statobottne = true;
                                        linee.bottoniEditi = true;
                                      }

                                      // Linee.importo = parseFloat(
                                      //   Linee.importo / 100
                                      // );
                                      // Linee.importoRidotto = parseFloat(
                                      //   Linee.importoRidotto / 100
                                      // );
                                      // var arrayDiImporto = linee.importo.toString().split("");

                                      // console.log(arrayDiImporto[arrayDiImporto.length - 1]);
                                      // if (arrayDiImporto[arrayDiImporto.length - 1] === "0") {
                                      //   linee.importo = linee.importo + "0";
                                      // }

                                      linee.importo = parseFloat(
                                        linee.importo / 100
                                      )
                                        .toFixed(2)
                                        .toString()
                                        .replace(".", ",");

                                      // var arrayDiIMportoRidotto = linee.importoRidotto.toString().split("");

                                      // console.log(arrayDiIMportoRidotto[arrayDiIMportoRidotto.length - 1]);
                                      // if (arrayDiIMportoRidotto[arrayDiIMportoRidotto.length - 1] === "0") {
                                      //   linee.importoRidotto = linee.importoRidotto + "0";
                                      // }

                                      linee.importoRidotto = parseFloat(
                                        linee.importoRidotto / 100
                                      )
                                        .toFixed(2)
                                        .toString()
                                        .replace(".", ",");
                                    });

                                    //   console.log(Linee);
                                    this.setState({ TipologiaSanzione: Linee });
                                  }
                                );
                                this.setState({ loading: false });
                              }
                              //   this.dashboardTipologiaSanzioneService.getDataTableTipologiaSanzione(
                              //     (Linee) => {
                              //       Linee.map((linee, indeds) => {
                              //         if (indeds === index) {
                              //           linee.statobottne = false;
                              //           linee.bottoniEditi = false;
                              //         } else {
                              //           linee.statobottne = true;
                              //           linee.bottoniEditi = true;
                              //         }
                              //       });

                              //       //   console.log(Linee);
                              //       this.setState({ TipologiaSanzione: Linee });
                              //     }
                              //   );
                              //   this.setState({ loading: false });
                              // }
                            }
                          >
                            {" "}
                            <i className="fas fa-fw fa-edit"></i>{" "}
                          </button>
                          &nbsp;
                          <button
                            className="btn btn-danger"
                            onClick={() =>
                              this.setState({
                                eliminaModal: true,
                                idDaEliminare:
                                  linee.idAnagrafiaTipolagiaSanzione,
                              })
                            }
                          >
                            {" "}
                            <i className="fas fa-fw fa-trash"></i>{" "}
                          </button>
                          &nbsp;
                        </>
                      ) : (
                        <>
                          <button
                            className="btn btn-success"
                            disabled={this.state.loadingButton}
                            onClick={() => {
                              //   console.log(this.state.TipologiaSanzione[index]);
                              // if (this.state.TipologiaSanzione[index].speseProcedura === 0) {
                              //   this.state.TipologiaSanzione[index].speseProcedura = false;
                              // }else{
                              //   this.state.TipologiaSanzione[index].speseProcedura = true;
                              // }
                              // if (this.state.TipologiaSanzione[index].aggiungiPrezzoTratta === 0) {
                              //   this.state.TipologiaSanzione[index].aggiungiPrezzoTratta = false;
                              // }else{
                              //   this.state.TipologiaSanzione[index].aggiungiPrezzoTratta = true;
                              // }
                              if (
                                this.state.TipologiaSanzione[index]
                                  .aggiungiPrezzoTratta === 0
                              ) {
                                this.state.TipologiaSanzione[
                                  index
                                ].aggiungiPrezzoTratta = false;
                              }
                              if (
                                this.state.TipologiaSanzione[index]
                                  .aggiungiPrezzoTratta === 1
                              ) {
                                this.state.TipologiaSanzione[
                                  index
                                ].aggiungiPrezzoTratta = true;
                              }
                              if (
                                this.state.TipologiaSanzione[index]
                                  .speseProcedura === 0
                              ) {
                                this.state.TipologiaSanzione[
                                  index
                                ].speseProcedura = false;
                              }
                              if (
                                this.state.TipologiaSanzione[index]
                                  .speseProcedura === 1
                              ) {
                                this.state.TipologiaSanzione[
                                  index
                                ].speseProcedura = true;
                              }
                              this.lineaEdit = {
                                idAnagrafiaTipolagiaSanzione:
                                  this.state.TipologiaSanzione[index]
                                    .idAnagrafiaTipolagiaSanzione,
                                nomeViolazione:
                                  this.state.TipologiaSanzione[index]
                                    .nomeViolazione,
                                normaDiRiferimento:this.state.TipologiaSanzione[index].normaDiRiferimento,
                                importo:
                                  this.state.TipologiaSanzione[index].importo,
                                importoRidotto:
                                  this.state.TipologiaSanzione[index]
                                    .importoRidotto,
                                speseProcedura:
                                  this.state.TipologiaSanzione[index]
                                    .speseProcedura === true
                                    ? 1
                                    : 0,
                                aggiungiPrezzoTratta:
                                  this.state.TipologiaSanzione[index]
                                    .aggiungiPrezzoTratta === true
                                    ? 1
                                    : 0,
                              };

                              if (
                                this.lineaEdit.importoRidotto
                                  .toString()
                                  .includes(",")
                              ) {
                                this.impoRIdo = this.lineaEdit.importoRidotto
                                  .toString()
                                  .replace(",", "");
                                this.impoRIdo =
                                  this.impoRIdo.toString().length === 1
                                    ? parseFloat(this.impoRIdo * 100)
                                    : parseFloat(this.impoRIdo).toFixed(2);

                                this.lineaEdit.importoRidotto = parseFloat(
                                  this.impoRIdo
                                );
                              } else {
                                this.impoRIdo =
                                  this.lineaEdit.importoRidotto.toString()
                                    .length < 3
                                    ? parseFloat(
                                        this.lineaEdit.importoRidotto * 100
                                      )
                                    : parseFloat(
                                        this.lineaEdit.importoRidotto
                                      ).toFixed(2);
                                if (
                                  this.lineaEdit.importoRidotto
                                    .toString()
                                    .includes(".")
                                ) {
                                  this.impoRIdo = this.lineaEdit.importoRidotto
                                    .toString()
                                    .replace(".", "");
                                }

                                this.lineaEdit.importoRidotto = parseFloat(
                                  this.impoRIdo
                                );
                              }
                              if (
                                this.lineaEdit.importo.toString().includes(",")
                              ) {
                                this.imp = this.lineaEdit.importo
                                  .toString()
                                  .replace(",", "");
                                this.imp =
                                  this.imp.toString().length < 3
                                    ? parseFloat(this.imp * 100)
                                    : parseFloat(this.imp).toFixed(2);

                                this.lineaEdit.importo = parseFloat(this.imp);
                              } else {
                                this.imp =
                                  this.lineaEdit.importo.toString().length === 1
                                    ? parseFloat(this.lineaEdit.importo * 100)
                                    : parseFloat(
                                        this.lineaEdit.importo
                                      ).toFixed(2);
                                if (
                                  this.lineaEdit.importo
                                    .toString()
                                    .includes(".")
                                ) {
                                  this.imp = this.lineaEdit.importo
                                    .toString()
                                    .replace(".", "");
                                }

                                this.lineaEdit.importo = parseFloat(this.imp);
                                // }
                              }
                              this.setState({loadingButton:true})
                              this.dashboardTipologiaSanzioneService.salvaModifica(
                                this.lineaEdit,
                                (result) => {
                                  this.setState({loadingButton:false})
                                  if (result.status === 200) {
                                    // console.log(this.lineaEdit);
                                    toast.success(
                                      "Tipologia Sanzione Aggiornata"
                                    );
                                  } else {
                                    // console.log(this.lineaEdit);
                                    toast.error(
                                      "Tipologia Sanzione non Aggiornata"
                                    );
                                  }
                                  this.dashboardTipologiaSanzioneService.getDataTableTipologiaSanzione(
                                    (Linee) => {
                                      Linee.map((linee) => {
                                        linee.statobottne = true;
                                        linee.bottoniEditi = true;
                                        if (Linee.speseProcedura === 0) {
                                          Linee.speseProcedura = false;
                                        } else {
                                          Linee.speseProcedura = true;
                                        }
                                        if (Linee.aggiungiPrezzoTratta === 0) {
                                          Linee.aggiungiPrezzoTratta = false;
                                        } else {
                                          Linee.aggiungiPrezzoTratta = true;
                                        }

                                        //                           var arrayDiIMportoRidotto = linee.importoRidotto.toString().split("");

                                        // console.log(arrayDiIMportoRidotto[arrayDiIMportoRidotto.length - 1]);
                                        // if (arrayDiIMportoRidotto[arrayDiIMportoRidotto.length - 1] === "0") {
                                        //   linee.importoRidotto = linee.importoRidotto + "0";
                                        // }

                                        linee.importoRidotto = parseFloat(
                                          linee.importoRidotto / 100
                                        )
                                          .toFixed(2)
                                          .toString()
                                          .replace(".", ",");

                                        // this.importo = linee.importo + "0";
                                        // var arrayDiImporto = linee.importo
                                        //   .toString()
                                        //   .split("");

                                        // console.log(
                                        //   arrayDiImporto[
                                        //     arrayDiImporto.length - 1
                                        //   ]
                                        // );
                                        // if (arrayDiImporto[arrayDiImporto.length - 1] === "0") {
                                        //   linee.importo = linee.importo + "0";
                                        // }

                                        linee.importo = parseFloat(
                                          linee.importo / 100
                                        )
                                          .toFixed(2)
                                          .toString()
                                          .replace(".", ",");
                                        // Linee.importo = parseFloat(
                                        //   Linee.importo / 100
                                        // );
                                        // Linee.importoRidotto = parseFloat(
                                        //   Linee.importoRidotto / 100
                                        // );
                                      });
                                      this.setState({
                                        TipologiaSanzione: Linee,
                                      });
                                    }
                                  );
                                }
                              );
                            }}
                          >
                            {" "}
                            {this.state.loadingButton ? <LoadSpinner/> : <i className="fas fa-fw fa-check"></i>}
                            {" "}
                          </button>
                          &nbsp;
                          <button
                            className="btn btn-danger"
                            id={index}
                            onClick={() => {
                              this.dashboardTipologiaSanzioneService.getDataTableTipologiaSanzione(
                                (Linee) => {
                                  Linee.map((linee, indeds) => {
                                    if (indeds === index) {
                                      linee.statobottne = true;
                                      linee.bottoniEditi = true;
                                    } else {
                                      linee.statobottne = true;
                                      linee.bottoniEditi = true;
                                    }
                                    linee.importoRidotto = parseFloat(
                                      linee.importoRidotto / 100
                                    );

                                    // linee.importoRidotto = parseFloat(
                                    //   this.impoRIdo
                                    // );
                                    //                           var arrayDiImporto = linee.importo.toString().split("");

                                    // console.log(arrayDiImporto[arrayDiImporto.length - 1]);
                                    // if (arrayDiImporto[arrayDiImporto.length - 1] === "0") {
                                    //   linee.importo = linee.importo + "0";
                                    // }

                                    linee.importo = parseFloat(
                                      linee.importo / 100
                                    )
                                      .toFixed(2)
                                      .toString()
                                      .replace(".", ",");
                                  });
                                  this.setState({ TipologiaSanzione: Linee });
                                }
                              );
                              this.setState({ loading: false });
                            }}
                          >
                            {" "}
                            <i className="fas fa-fw fa-times"></i>{" "}
                          </button>
                          &nbsp;
                        </>
                      )}
                    </td>
                  </tr>
                </>
              );
            })}
          </tbody>
        </table>
      </>
    );
  }
  render() {
    // console.log(this.state.TipologiaSanzione);
    let content = this.state.loading ? (
      <LoadSpinner />
    ) : (
      <div id="wrapper">
        <Menucustom />
        <div className="container-fluid">
          <br />
          <br />
          <div className="d-sm-flex align-items-center justify-content-between mb-4">
            <h1 className="h1 mb-2 text-gray-800">
              Gestione Tipologia Sanzione<br></br>
            </h1>
            {/* <small
                style={{ fontSize: "14px" }}
                className="mb-2 text-gray-800"
              > 
                Aree &#8594; In Lavorazione
              </small>< */}

            <button
              type="button"
              class="btn btn-warning"
              onClick={() => {
                this.setState({ AggiungiUnaLinea: true });
              }}
            >
              {" "}
              <i className="fas fa-plus fa-sm text-white"></i> &nbsp;Aggiungi
              una nuova Tipologia Sanzione
            </button>
            <a className=""></a>
          </div>
          <br />
          <br />
          <div className="col">{this.tabellaAree()}</div>
          {this.eliminaModal()}
          {this.AggiungiUnaLinea()}
        </div>
      </div>
    );
    return <div>{content}</div>;
  }
}
export default withRouter(TipologiaSanzione);
